import api from './api';
import { CourseInfo, UnitInfo, CourseSentence } from '../types';

/**
 * 获取所有课程列表
 */
export async function getCourses(): Promise<CourseInfo[]> {
  const response = await api.get('api/courses');
  return response.data;
}

/**
 * 获取指定课程下的所有单元
 */
export async function getCourseUnits(courseId: string): Promise<UnitInfo[]> {
  const response = await api.get(`api/courses/${courseId}/units`);
  return response.data;
}

/**
 * 获取指定单元下的所有句子
 */
export async function getUnitSentences(unitId: string): Promise<CourseSentence[]> {
  const response = await api.get(`api/units/${unitId}/sentences`);
  return response.data;
}

